import React, { useMemo } from 'react';
import toast from 'react-hot-toast';
import { updateUser as updateUserApi } from '@core/api/user';
import ProfileForm, {
  type ProfileFormValues,
  getProfileDefaultValues,
  toProfilePayload,
} from '@core/components/forms/ProfileForm';
import { useAuth } from '@core/contexts/AuthContext';
import FormDialog from './FormDialog';

export interface ProfileDialogProps {
  open: boolean;
  onClose: () => void;
}

const ProfileDialog: React.FC<ProfileDialogProps> = ({ open, onClose }) => {
  const { user, updateUser: setAuthUser } = useAuth();

  const defaultValues = useMemo(() => getProfileDefaultValues(user), [user]);

  const onSubmit = async (data: ProfileFormValues) => {
    if (!user) {
      return;
    }

    const updatedUser = await updateUserApi(user.id, toProfilePayload(data));
    setAuthUser(updatedUser);
    toast.success('Profile updated successfully');
    onClose();
  };

  if (!user) {
    return null;
  }

  return (
    <FormDialog<ProfileFormValues>
      open={open}
      onClose={onClose}
      title="Profile"
      defaultValues={defaultValues}
      onSubmit={onSubmit}
      submitText="Save"
      cancelText="Cancel"
    >
      <ProfileForm />
    </FormDialog>
  );
};

export default ProfileDialog;
